<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ '::Default' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ng-container *ngComponentOutlet="abpEmailSettingGroup"></ng-container>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Dashboard::Reports' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <form [formGroup]="reportEmailSettingsForm" (ngSubmit)="onSubmitReportEmailSettings()">
          <div class="form-group pt-2">
            <label for="displayName">
              {{ 'Settings::Emailing:DisplayName' | abpLocalization }}
              <span class="indicates-required-field-info">*</span>
            </label>
            <input class="form-control form-control-sm" type="text" formControlName="displayName" />
          </div>
          <div class="form-group pt-2">
            <label for="address">
              {{ 'Settings::Emailing:Address' | abpLocalization }}
              <span class="indicates-required-field-info">*</span>
            </label>
            <input class="form-control form-control-sm" type="text" formControlName="address" />
          </div>
          <div class="form-group pt-2">
            <label for="username">
              {{ 'AbpEmailing::DisplayName:Abp.Mailing.Smtp.UserName' | abpLocalization }}
            </label>
            <input class="form-control form-control-sm" type="text" formControlName="username" />
          </div>
          <div class="form-group pt-2">
            <label for="password">
              {{ 'AbpEmailing::DisplayName:Abp.Mailing.Smtp.Password' | abpLocalization }}
            </label>
            <input
              class="form-control form-control-sm"
              type="password"
              formControlName="password"
              [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization" />
          </div>
          <button type="submit" class="btn btn-primary mt-3">
            <i class="me-1 fas fa-save"></i>
            {{ 'AbpUi::Save' | abpLocalization }}
          </button>
        </form>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>
